import { render, staticRenderFns } from "./65bdzgc.vue?vue&type=template&id=6164b28e&"
import script from "./65bdzgc.vue?vue&type=script&lang=js&"
export * from "./65bdzgc.vue?vue&type=script&lang=js&"
import style0 from "./65bdzgc.vue?vue&type=style&index=0&id=6164b28e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports